import axios from "axios";
import { BASE_URL } from "../constants/constants";


const api = axios.create({
  baseURL: BASE_URL,
  // timeout: 3600,
  headers: {
    Accept: "application/json",
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'X-Content-Type-Options': "nosniff",
    "X-XSS-Protection": "1; mode=block"
  }
});

// Auth Services


export function getAllInstitutionAndResearch(libelle) {

  const response = api.get(`api/All-institution?libelle=${libelle}`);
  return response.then((data) => data).catch((error) => error);
}




export function getPresentation() {
  const response = api.get(`api/about`);
  return response.then((data) => data).catch((error) => error);
}

// Comparateur Services
export function getAllCategoryAndZone() {
  const response = api.get(`api/categoryZoneList`);
  return response.then((data) => data).catch((error) => error);
}

export function getInstitutionsComparisionData(data) {
 console.log(data)
 const dataToSend = {
  "institution":data
 }
  const response = api.post("api/comparisonOfInstitution", dataToSend);
  return response.then((data) => data).catch((error) => error);
}

export function getInstitutionFromCategoryAndZone(category, zone) {
  const formData = new FormData();
  formData.append("category", category);
  formData.append("zone", zone);
  const response = api.post("api/InstitutionsFromcategoryzone", formData);
  return response.then((data) => data).catch((error) => error);
}


// Institution Details Services 
export function getInstitutionDetails(institution, category) {
  const response = api.get(`api/get-InstitutionDetail/${institution}?category=${category}`);
  return response.then((data) => data).catch((error) => error);
}

export function getInstitutionRate(institution) {
  const response = api.get(`api/institution-rate/${institution}`);
  return response.then((data) => data).catch((error) => error);
}

export function getCategoryProductFilterList() {
  const response = api.get(`api/categoryProductList-Gate`);
  return response.then((data) => data).catch((error) => error);
}

export function getAppsConfig() {
  const response = api.get(`api/get-applicationConfiguration`);
  return response.then((data) => data).catch((error) => error);
}


